import path from 'path'
import { getRegexFromString } from '@jarvis.oddle/core/tools/string'
import { origin, API_ROOT, IG_API_ROOT, CUST_API_ROOT, PORT } from './universal'

export const APP_BASE_PATH = path.resolve(__dirname)
export const GIT_INFO_ENABLED = process.env.GIT_INFO_ENABLED || true

export const INSTAGRAM_SECRET_KEY = process.env.INSTAGRAM_SECRET_KEY
export const V3_API_TARGET =
  process.env.V3_API_TARGET || 'https://api.beta.oddle.me'
export const V3_CART_REGEX =
  getRegexFromString(process.env.V3_CART_REGEX) ||
  /(?:(http(s)?:\/\/)?([^.]+)\.)?(beta\.)oddle\.me/
export const SUBDOMAIN_URL_HEADER = 'subdomain-url'
export const CART_BASE_URL =
  process.env.CART_BASE_URL || `http://__name__.localhost:${PORT}`
export const SUBDOMAIN_REGEX =
  getRegexFromString(process.env.SUBDOMAIN_REGEX) || /(?:([^.]+)\.)?localhost/i
// this secret key only use at localhost to get accessToken from OP server when customer access to Shop from Eats,
// we do this because when Shop run on locally and Eats on beta, they can’t share _oid_s cookies
export const OP_SECRET_KEY_AUTHORIZATION =
  process.env.OP_SECRET_KEY_AUTHORIZATION ||
  '2a7fdcf2-feb5-4dbf-aa03-5eb1e3570f5e'

// NOTE: Enable below settings for customisation module development
// export const CUSTOMISATION_BACKEND_BASE_URL = process.env.CUSTOMISATION_BACKEND_BASE_URL || 'http://customisation.localhost/api/customisation/v1'
export const CUSTOMISATION_BACKEND_BASE_URL =
  process.env.CUSTOMISATION_BACKEND_BASE_URL ||
  'https://beta.oddle.me/api/customisation/v1'

export const REDIS_URL = process.env.REDIS_URL || 'redis://127.0.0.1:6379'

const DEFAULT_ROBOTS_TXT = '../static/robotstxt/default.txt'
const ROBOTS_TXT_RELATIVE_PATH = process.env.ROBOTS_TXT || DEFAULT_ROBOTS_TXT
export const ROBOTS_TXT_ABSOLUTE_PATH = path.join(
  __dirname,
  ROBOTS_TXT_RELATIVE_PATH
)

const FAVICON_RELATIVE_PATH = '../static/favicon.ico'
export const FAVICON_ABSOLUTE_PATH = path.join(__dirname, FAVICON_RELATIVE_PATH)

export const VOUCHERIFY_API_KEY =
  process.env.VOUCHERIFY_API_KEY || '4e198bf5-b437-4056-b674-644694f8273e'
export const VOUCHERIFY_APP_TOKEN =
  process.env.VOUCHERIFY_APP_TOKEN || '9a90502b-f8d2-4974-a41a-f6b7557dd2fa'
export const VOUCHERIFY_DOMAIN =
  process.env.VOUCHERIFY_DOMAIN || 'https://as1.api.voucherify.io'

export const SECRET_KEY_LOGISTIC_API =
  process.env.SECRET_KEY_LOGISTIC_API ||
  '579975d5892e44f4b6edfb40322016a6zWRSw0OyHzpB9BWdTZmwxShy1s-Th84MXKAIVZFkY-8='
export const NODE_ENV = process.env.NODE_ENV
export const OP_API_BASE_URL =
  process.env.OP_API_BASE_URL || 'https://accounts.beta.oddle.me/api/v1'

export const redisDBName = {
  voucherSession: 1,
  translationMessages: 2,
  serverSideProps: 3
}

export { origin, API_ROOT, IG_API_ROOT, CUST_API_ROOT, PORT }
